export const CYPRESS_BYPASS_COVERAGE_KEY = 'bypass-cypress-coverage';
